export default __webpack_public_path__ + "static/media/03.7baf65dd.mp3";